import React, { useState, FunctionComponent, useEffect, useCallback } from 'react';
import { Presentation } from './presentation';
import { PersonShowModalFavoriteBrandState } from './types';
import { fetchRecommendBrands } from '../../../services/personProfiles';

type Props = {
  onChangedBody: (name: string, value: any) => void;
  favoriteBrands: string[];
  target: string;
  onRegisterCommitHandler?: (handler: () => string[]) => void;
};

export const Component: FunctionComponent<Props> = ({
  onChangedBody,
  favoriteBrands: initialBrands,
  target,
  onRegisterCommitHandler,
}) => {
  const [state, setState] = useState<PersonShowModalFavoriteBrandState>({
    favoriteBrands: [],
    targetBrand: '',
    isSearching: true,
    suggestBrands: [],
  });

  useEffect(() => {
    setState(prev => ({ ...prev, favoriteBrands: initialBrands }));
  }, [initialBrands]);

  const handleChange = (name: string, value: string) => {
    setState(prev => ({ ...prev, targetBrand: value }));
    if (value === '') {
      setState(prev => ({ ...prev, setIsSearching: false, suggestBrands: [] }));
    } else {
      setState(prev => ({ ...prev, setIsSearching: true, }));
      if (value.length > 2) handleSearch(value);
    }
  };

  const handleSearch = async (target: string) => {
    try {
      const response = await fetchRecommendBrands(target);
      setState(prev => ({ ...prev, suggestBrands: response.suggestBrands, }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleClick = (value: string) => {
    if (!state.favoriteBrands.includes(value)) {
      const updated = [...state.favoriteBrands, value];
      setState(prev => ({ ...prev, favoriteBrands: updated, }));
      onChangedBody('favoriteBrands', updated);
    }
    setState(prev => ({ ...prev, suggestBrands: [], setIsSearching: false, targetBrand: '' }));
  };

  const handleDelete = (value: string) => {
    const updated = state.favoriteBrands.filter((b) => b !== value);
    setState(prev => ({ ...prev, favoriteBrands: updated }));
    onChangedBody('favoriteBrands', updated);
  };

  const handleSend = (e: React.KeyboardEvent<HTMLInputElement>) => {
    const value = (e.target as HTMLInputElement).value;
    if (!state.favoriteBrands.includes(value)) {
      const updated = [...state.favoriteBrands, value];
      setState(prev => ({ ...prev, favoriteBrands: updated }));
      onChangedBody('favoriteBrands', updated);
      setState(prev => ({ ...prev, setIsSearching: false, targetBrand: '' }));
    }
  };

  const handleClearSuggest = () => {
    setState(prev => ({ ...prev, suggestBrands: [], setIsSearching: false, }));
  };

  const getFavoriteBrandsForSave = useCallback((): string[] => {
    const value = state.targetBrand.trim();
    if (value && !state.favoriteBrands.includes(value)) {
      return [...state.favoriteBrands, value];
    }
    return state.favoriteBrands;
  }, [state.targetBrand, state.favoriteBrands]);

  useEffect(() => {
    onRegisterCommitHandler?.(getFavoriteBrandsForSave);
  }, [getFavoriteBrandsForSave, onRegisterCommitHandler]);

  return (
    <Presentation
      favoriteBrands={state.favoriteBrands}
      targetBrand={state.targetBrand}
      isSearching={state.isSearching}
      suggestBrands={state.suggestBrands}
      onChangeBody={handleChange}
      onClickBrand={handleClick}
      onDeleteBrand={handleDelete}
      onSendBrand={handleSend}
      onClearSuggest={handleClearSuggest}
    />
  );
};
